
import { createReducer } from "@reduxjs/toolkit";

export const adminReducer = createReducer(
  {},
  {



    getAdminStatsRequest: (state) => {
      state.loading = true;
    },
    getAdminStatsSuccess: (state, action) => {
      state.loading = false;
      state.stats = action.payload.stats;
      state.viewsCount = action.payload.viewsCount;
      state.usersCount = action.payload.usersCount;
      state.subscriptionsCount = action.payload.subscriptionsCount;
      state.viewPercentage = action.payload.viewPercentage;
      state.userPercentage = action.payload.userPercentage;
      state.subscriptionProfit = action.payload.subscriptionProfit;
      state.viewProfit = action.payload.viewProfit;
      state.userProfit = action.payload.userProfit;
    },
    
    getAdminStatsFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },


    getAllUsersRequest: (state) => {
      state.loading = true;
    },
    getAllUsersSuccess: (state, action) => {
      state.loading = false;
      state.users = action.payload;
    },
    getAllUsersFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    deleteAllUserRequest: (state) => {
      state.loading = true;
    },
    deleteAllUserSuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload;
    },
    deleteAllUserFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },



    createCourseRequest: (state) => {
      state.loading = true;
    },
    createCourseSuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload;
    },
    createCourseFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    deleteCourseRequest: (state) => {
      state.loading = true;
    },
    deleteCourseSuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload;
    },
    deleteCourseFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },


    addLecturesRequest: (state) => {
      state.loading = true;
    },
    addLecturesSuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload;
    },
    addLecturesFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },


    deleteLecturesRequest: (state) => {
      state.loading = true;
    },
    deleteLecturesSuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload;
    },
    deleteLecturesFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  }
);
